import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { useSelector, useDispatch } from 'react-redux';
import tick from '../../../../../../../assets/images/tick.svg';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-success.module.scss';
import Header from '../../../../../../../components/Stake/header';
import { formatToken } from '../../../../../../../helpers/token-helper';
import TxID from '../../../../../../../components/txID';
import { initData } from '../../../../../../../actions/delegator-reward-actions';
import { MERKLE_AIRDROP_NAMES } from '../../../../../../../constants/blockchain-constants';
import styled from 'styled-components';
import PolygonLogo from '../../../../../../../external/components/Icon/polygon';

const PolyLogo = styled(PolygonLogo)`
  width: 34px;
  height: 34px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

const ClaimSuccess = ({ setStatus }) => {
  const dispatch = useDispatch();
  const { hash, successAmount } = useSelector((state) => state.delegator.matic);

  const done = () => {
    dispatch(initData(MERKLE_AIRDROP_NAMES.MATIC));
  };

  return (
    <>
      <Header componentIcon={<PolyLogo />} title='OM-Claim' />
      <div className={stylesParent.cardContent}>
        <div className={styles.icon}>
          <img src={tick} alt='' />
        </div>
        <div className={styles.stakedValue}>{formatToken(successAmount)} OM</div>
        <div className={styles.status}>Rewards Claimed</div>
        <TxID id={hash} />
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => {
              done();
              setStatus(2);
            }}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
};

ClaimSuccess.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default ClaimSuccess;
